const navigation = {
  welcome: 'Welcome',
  rooms: 'Rooms',
  dining: 'Dining',
  promotions: 'Promotions',
  shanghai: 'Shanghai Restaurant',
  lavilla: 'LaVilla Restaurant',
  footer: 'Contact',
};

export default navigation;